module.exports = __webpack_public_path__ + "img/f8.cab33c08.png";